(function(){
"use strict";
/* ---------- reveal on scroll ---------- */
function initReveal(root){
  var els=(root||document).querySelectorAll('.sj-reveal:not(.is-in)');
  if(!('IntersectionObserver' in window)){els.forEach(function(e){e.classList.add('is-in')});return;}
  var io=new IntersectionObserver(function(entries){entries.forEach(function(en){if(en.isIntersecting){en.target.classList.add('is-in');io.unobserve(en.target);}})},{threshold:.12,rootMargin:'0px 0px -40px 0px'});
  els.forEach(function(e){io.observe(e)});
}
/* ---------- money ---------- */
function money(cents,fmt){
  fmt=fmt||window.SJ_MONEY||'${{amount}}';
  var v=(cents/100);
  var a=v.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g,',');
  var b=v.toFixed(2).replace('.',',').replace(/\B(?=(\d{3})+(?!\d))/g,'.');
  return fmt.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/,b).replace(/\{\{\s*amount_no_decimals\s*\}\}/,Math.round(v).toString()).replace(/\{\{\s*amount\s*\}\}/,a);
}
window.sjMoney=money;
/* ---------- cart ---------- */
function addToCart(items,btn){
  if(btn){btn.classList.add('is-loading');btn.disabled=true;}
  var drawer=document.querySelector('cart-drawer');
  var body={items:items};
  if(drawer){body.sections='cart-drawer,cart-icon-bubble';body.sections_url=window.location.pathname;}
  return fetch((window.Shopify&&Shopify.routes?Shopify.routes.root:'/')+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)})
  .then(function(r){return r.json()})
  .then(function(res){
    if(res.status&&res.description){alert(res.description);return;}
    if(drawer&&res.sections&&typeof drawer.renderContents==='function'){
      drawer.classList.remove('is-empty');
      drawer.renderContents(res);
    }else{window.location.href='/cart';}
  })
  .catch(function(){window.location.href='/cart';})
  .finally(function(){if(btn){btn.classList.remove('is-loading');btn.disabled=false;}});
}
window.sjAddToCart=addToCart;
function buyNow(items){
  var path=items.map(function(i){return i.id+':'+i.quantity}).join(',');
  window.location.href='/cart/'+path;
}
window.sjBuyNow=buyNow;
/* ---------- product form ---------- */
function initProduct(form){
  if(form.dataset.ready)return;form.dataset.ready='1';
  var data=JSON.parse(form.querySelector('script[data-sj-product]').textContent);
  var state={vid:data.selected,qty:1,pair:false,pairVid:null};
  var root=form.closest('.sj-product')||document;
  function variant(id){return data.variants.find(function(v){return v.id==id})}
  function pct(q){return q>=3?data.d3:(q==2?data.d2:0)}
  function render(){
    var v=variant(state.vid); if(!v)return;
    form.querySelectorAll('.sj-swatch').forEach(function(b){b.classList.toggle('is-active',b.dataset.vid==state.vid);b.setAttribute('aria-pressed',b.dataset.vid==state.vid)});
    var name=form.querySelector('[data-sj-color-name]'); if(name)name.textContent=v.title;
    form.querySelectorAll('.sj-bundle__opt').forEach(function(o){
      var q=+o.dataset.qty, p=pct(q), full=v.price*q, now=Math.round(full*(100-p)/100);
      o.classList.toggle('is-active',q==state.qty);
      o.querySelector('[data-now]').textContent=money(now);
      var was=o.querySelector('[data-was]'); if(was){was.textContent=p?money(full):'';}
    });
    var p=pct(state.qty), full=v.price*state.qty, now=Math.round(full*(100-p)/100);
    var pn=form.querySelector('[data-sj-price]'); if(pn)pn.textContent=money(now);
    var pw=form.querySelector('[data-sj-was]'); if(pw){pw.textContent=p?money(full):'';}
    var ps=form.querySelector('[data-sj-save]'); if(ps){ps.textContent=p?('-'+p+'% bundle'):'';ps.style.display=p?'':'none';}
    var atcLabel=form.querySelector('[data-sj-atc-label]'); if(atcLabel)atcLabel.textContent=(state.qty>1?('Add '+state.qty+' to cart'):'Add to cart')+' — '+money(now);
    var atc=form.querySelector('.sj-atc'); if(atc){atc.disabled=!v.available; if(!v.available&&atcLabel)atcLabel.textContent='Sold out';}
    /* pair box */
    var pairSel=form.querySelector('[data-sj-pair-select]');
    if(pairSel){state.pairVid=pairSel.value;}
    var pairPrice=form.querySelector('[data-sj-pair-price]');
    if(pairPrice){var pv=pairSel?variant(pairSel.value):null; var pp=data.pairPrice||(pv?pv.price:v.price); var tot=v.price+pp; pairPrice.innerHTML='<s>'+money(tot)+'</s> <b>'+money(Math.round(tot*(100-data.d2)/100))+'</b>';}
    /* media */
    if(v.media){var t=root.querySelector('.sj-thumb[data-media="'+v.media+'"]'); if(t)showMedia(t);}
    var url=new URL(window.location.href); url.searchParams.set('variant',v.id); history.replaceState(null,'',url.toString());
    var hid=form.querySelector('input[name="id"]'); if(hid)hid.value=v.id;
  }
  function showMedia(t){
    var main=root.querySelector('.sj-gallery__main img'); if(!main)return;
    main.src=t.dataset.src; main.srcset=t.dataset.srcset||''; main.alt=t.dataset.alt||'';
    root.querySelectorAll('.sj-thumb').forEach(function(x){x.classList.toggle('is-active',x===t)});
    main.parentElement.classList.remove('sj-pop');void main.offsetWidth;main.parentElement.classList.add('sj-pop');
  }
  root.querySelectorAll('.sj-thumb').forEach(function(t){t.addEventListener('click',function(){showMedia(t)})});
  form.querySelectorAll('.sj-swatch').forEach(function(b){b.addEventListener('click',function(){state.vid=+b.dataset.vid;render()})});
  form.querySelectorAll('.sj-bundle__opt').forEach(function(o){o.addEventListener('click',function(){state.qty=+o.dataset.qty;render()})});
  var pairSel=form.querySelector('[data-sj-pair-select]'); if(pairSel)pairSel.addEventListener('change',render);
  function items(){return [{id:state.vid,quantity:state.qty}]}
  var atc=form.querySelector('.sj-atc'); if(atc)atc.addEventListener('click',function(e){e.preventDefault();addToCart(items(),atc)});
  var bn=form.querySelector('.sj-buynow'); if(bn)bn.addEventListener('click',function(e){e.preventDefault();buyNow(items())});
  var pairBtn=form.querySelector('[data-sj-pair-add]'); if(pairBtn)pairBtn.addEventListener('click',function(e){e.preventDefault();var second=data.pairVariant||+(pairSel&&pairSel.value);addToCart([{id:state.vid,quantity:1},{id:second,quantity:1}],pairBtn)});
  render();
}
/* ---------- stories ---------- */
function initStories(sec){
  if(sec.dataset.ready)return;sec.dataset.ready='1';
  var stories=JSON.parse(sec.querySelector('script[data-sj-stories]').textContent);
  var modal=sec.querySelector('.sj-story-modal'); if(!modal)return;
  var stage=modal.querySelector('.sj-story-modal__stage'), bars=modal.querySelector('.sj-story-modal__bars'), title=modal.querySelector('[data-sj-st-title]'), cap=modal.querySelector('[data-sj-st-cap]'), buy=modal.querySelector('[data-sj-st-buy]'), view=modal.querySelector('[data-sj-st-view]');
  var idx=0,timer=null,start=0,dur=7000,raf=null;
  function clear(){clearTimeout(timer);cancelAnimationFrame(raf);}
  function tick(){var el=bars.children[idx]; if(!el)return; var p=Math.min(1,(Date.now()-start)/dur); el.firstChild.style.width=(p*100)+'%'; if(p<1)raf=requestAnimationFrame(tick);}
  function show(i){
    clear(); if(i<0)i=0; if(i>=stories.length){close();return;} idx=i; var s=stories[i];
    bars.innerHTML=stories.map(function(_,k){return '<span><i style="width:'+(k<i?100:0)+'%"></i></span>'}).join('');
    stage.innerHTML='';
    if(s.video){var v=document.createElement('video');v.src=s.video;v.autoplay=true;v.muted=true;v.playsInline=true;v.setAttribute('playsinline','');stage.appendChild(v);v.play().catch(function(){});v.onloadedmetadata=function(){dur=Math.max(3000,Math.min(15000,v.duration*1000));start=Date.now();tick();clear();timer=setTimeout(function(){show(idx+1)},dur);raf=requestAnimationFrame(tick)};dur=8000;}
    else{var im=document.createElement('img');im.src=s.src;im.alt=s.title||'';stage.appendChild(im);dur=s.gif?6500:5000;}
    title.textContent=s.title||''; cap.textContent=s.caption||'';
    if(s.buy){buy.style.display='';buy.onclick=function(){buyNow([{id:s.buy,quantity:1}])};}else{buy.style.display='none';}
    if(s.url){view.style.display='';view.href=s.url;}else{view.style.display='none';}
    sec.querySelectorAll('.sj-story').forEach(function(b,k){if(k===i)b.classList.add('is-seen')});
    start=Date.now(); raf=requestAnimationFrame(tick); timer=setTimeout(function(){show(idx+1)},dur);
  }
  function open(i){modal.hidden=false;document.documentElement.style.overflow='hidden';requestAnimationFrame(function(){modal.classList.add('is-open')});show(i);}
  function close(){clear();modal.classList.remove('is-open');document.documentElement.style.overflow='';setTimeout(function(){modal.hidden=true;stage.innerHTML='';},250);}
  sec.querySelectorAll('.sj-story').forEach(function(b){b.addEventListener('click',function(){open(+b.dataset.index)})});
  modal.querySelector('[data-sj-st-close]').addEventListener('click',close);
  modal.querySelector('[data-sj-st-prev]').addEventListener('click',function(){show(idx-1)});
  modal.querySelector('[data-sj-st-next]').addEventListener('click',function(){show(idx+1)});
  document.addEventListener('keydown',function(e){if(modal.hidden)return;if(e.key==='Escape')close();if(e.key==='ArrowRight')show(idx+1);if(e.key==='ArrowLeft')show(idx-1);});
}
/* ---------- track ---------- */
function initTrack(f){
  if(f.dataset.ready)return;f.dataset.ready='1';
  f.addEventListener('submit',function(e){e.preventDefault();var n=(f.querySelector('input').value||'').trim().replace(/\s+/g,'');if(!n)return;window.open('https://t.17track.net/en#nums='+encodeURIComponent(n),'_blank','noopener');});
}
function init(root){
  initReveal(root);
  (root||document).querySelectorAll('.sj-pform').forEach(initProduct);
  (root||document).querySelectorAll('.sj-stories').forEach(initStories);
  (root||document).querySelectorAll('.sj-track-form').forEach(initTrack);
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',function(){init()})}else{init()}
document.addEventListener('shopify:section:load',function(e){init(e.target)});
})();